module.exports = __webpack_public_path__ + "images/sprites/ui/btn_car_cv_5c2928c107f3b0e545dd8fe3247d0b2b.png";